import { render, staticRenderFns } from "./taskRule.vue?vue&type=template&id=2d22ccbe&"
import script from "./taskRule.vue?vue&type=script&lang=js&"
export * from "./taskRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports